import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum EPrescriptionItemTypeEnum {
    MEDICATION = 'MEDICATION',
    MAGISTRALITER = 'MAGISTRALITER',
}

export const ePrescriptionItemTypeEnumOptions = enumToOptions(
    EPrescriptionItemTypeEnum,
    'ePrescriptions.itemTypeEnum.',
);
